

export const MUSEFLOW_ORANGE = '#CA7C62'
export const MUSEFLOW_OFF_WHITE_1 = '#CED0D4'
export const MUSEFLOW_OFF_WHITE_2 = '#ADB1B7'
export const MUSEFLOW_OFF_WHITE_3 = '#8D929F'
